import GlassCard from '@/components/GlassCard';
import { Subtitle, Text } from '@/components/Typography';
import { ChevronRight, Video } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface AmaSessionsCardProps {
    courseSlug: string;
}

const AmaSessionsCard: React.FC<AmaSessionsCardProps> = ({ courseSlug }) => {
    const { t } = useTranslation();

    return (
        <GlassCard
            as="link"
            href={`/courses/${courseSlug}/ama-series/`}
            className="flex items-center gap-4 p-5"
        >
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-theme-light">
                <Video className="h-6 w-6 text-theme-primary-text" />
            </div>

            <div className="min-w-0 flex-1">
                <Subtitle as="h2" className="text-base text-gray-800 dark:text-white">
                    {t('course.amaRecordedSessions', 'Sesiones AMA grabadas')}
                </Subtitle>
                <Text size="sm" muted className="mt-0.5 dark:text-neutral-400">
                    {t('course.viewRecordedAmaSessions', 'Ver sesiones de preguntas y respuestas grabadas')}
                </Text>
            </div>

            <ChevronRight className="h-5 w-5 shrink-0 text-gray-400 dark:text-neutral-500" />
        </GlassCard>
    );
};

export default AmaSessionsCard;
